import { useReviewsStore } from '~/stores/reviews'
import { computed } from 'vue'
import { useNuxtApp } from '#imports'

export const useReviews = (book) => {
  const reviewsStore = useReviewsStore()
  const { $label } = useNuxtApp()

  const bookSlug = computed(() => reviewsStore.bookSlug)
  const totalAmountOfRatings = computed(() =>
    bookSlug.value === book.slug ? reviewsStore.totalAmountOfRatings : 0
  )
  const reviewAverageRating = computed(() =>
    bookSlug.value === book.slug ? reviewsStore.averageRating : 0
  )
  const averageRating = computed(
    () => reviewAverageRating.value || book.averageRating
  )
  const numberOfRatings = computed(
    () => totalAmountOfRatings.value || book.numberOfRatings
  )

  const bookRatingsLabel = computed(() => {
    const label =
      numberOfRatings.value === 1
        ? 'books.reviews.numberOfRatingsSingular'
        : 'books.reviews.numberOfRatings'

    return $label(label, {
      numberOfRatings: numberOfRatings.value
    })
  })

  return {
    averageRating,
    numberOfRatings,
    bookRatingsLabel
  }
}
